import { numeric, required } from 'vuelidate/lib/validators'
import DatePeriodPicker from '@/components/common/dateperiodpicker/DatePeriodPicker.vue'

const defaultEl = {
  id: null,
  name: {},
  axaptCode: '',
  billName: {},
  material_group: null,
  material_category: null,
  measure_type: null,
  from_date_period_id: null,
  to_date_period_id: null,
  disabled: 0,
  code: '',
  order: '',
  autoApproveFilledInLast: null,
  info: {},
  reportSubcode: null
};

export default {
  data () {
    return {
      editEl: defaultEl,
      loading: false
    }
  },
  validations: {
    editEl: {
      name: { required },
      code: { required },
      order: { required, numeric },
      material_group: { required },
      from_date_period_id: { required },
      measure_type: { required }
    }
  },
  components: {
    DatePeriodPicker
  },
  computed: {
    getTitle () {
      if (this.editEl.id) {
        return this.$t('menu.material.edit');
      }
      return this.$t('menu.material.new');
    },
    materialCategoryOptions () {
      const options = this.$store.getters.getConfigOptions('material_categories', this.$i18n.locale, null, null, false, true);
      options.unshift({ code: null, text: this.$t('material-category.none-parent-category') });
      return this.BasicHelper.sortArrayByKeyValue(options, 'text');
    },
    materialGroupOptions () {
      return this.$store.getters.getConfigOptions('material_groups', this.$i18n.locale, null, null, false, true);
    },
    measureTypeOptions () {
      return this.$store.getters.getConfigOptions('measure_types', this.$i18n.locale, 'axaptCode', null, true, true);
    },
    yesNoOptions () {
      return this.BasicHelper.yesNoOptions();
    },
    reportOptions () {
      return this.ZPFormatHelper.getReportNameOptions(false, true);
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        if (elData.info === null) {
          elData.info = {};
        }
        if (elData.billName === null) {
          elData.billName = {};
        }
        this.editEl = this.BasicHelper.cloneObject(elData);
        this.editEl.material_group = this.$store.getters.getParamFromConfig('material_groups', this.editEl.material_group_id, 'code');
        this.editEl.measure_type = this.$store.getters.getParamFromConfig('measure_types', this.editEl.measure_type_id, 'code');
        if (this.editEl.material_category_id) {
          this.editEl.material_category = this.$store.getters.getParamFromConfig('material_categories', this.editEl.material_category_id, 'code');
        }
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.$v.$reset();
      this.$refs['modal-window'].show();
    },
    save () {
      this.$v.$touch();
      if (!this.$v.$invalid && !this.loading) {
        this.loading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        if (reqData.autoApproveFilledInLast === '') {
          reqData.autoApproveFilledInLast = null;
        }
        const self = this;
        this.ApiRequest.request('material/material/edit', this.ApiRequest.REQUEST_POST, { material: reqData }, function (response) {
          if (response.error) {
            self.ApiRequest.displayErrorDialog(response, self);
          } else {
            self.$emit('saved', response.data);
            self.close();
          }
          self.loading = false;
        });
      }
    },
    close () {
      this.$refs['modal-window'].hide();
    }
  }
}
